<div class="content-block">
    <form>

        <div class="row">
            <div class="col-12">
                <div class="dx-fieldset-header">Nome allegato</div>
                <dx-text-box [(value)]="nomeAllegato">
                    <dx-validator>
                        <dxi-validation-rule type="required" message="Inserire il nome"></dxi-validation-rule>
                    </dx-validator>
                </dx-text-box>
            </div>
            <div class="col-12 col-md-12">
                <div class="widget-container">
                    <div class="dx-fieldset-header">File </div>
                    <dx-file-uploader #fileUploader [multiple]="false" accept="*" [(value)]="value"
                        uploadMode="useForm">
                        <dx-validator>
                            <dxi-validation-rule type="required" message="Selezionare il file">
                            </dxi-validation-rule>
                        </dx-validator>
                    </dx-file-uploader>
                    <div class="content">
                        <div *ngIf="value.length > 0">
                            <h4>File selezionato</h4>
                        </div>
                        @for(file of value; track file){
                        <div>
                            <div class="selected-item">
                                Nome:<span>{{file.name}}</span>
                                <br /> Dimensione:<span>{{file.size}}</span>bytes
                                <br /> Tipo:<span>{{file.type}}</span>
                            </div>
                        </div>
                        }
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                &nbsp;
            </div>
        </div>

        <div class="row mt-4 pt-3 border-top">
            <div class="col-12">
                <dx-button stylingMode="contained" text="Allega" type="normal" type="success"
                    icon="fa fa-solid fa-upload" (onClick)="allegaFile($event, fileUploader.value)">
                </dx-button>
            </div>
        </div>

    </form>
</div>